// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%275%27 viewBox=%270 0 8 4%27%3E%3Cpath d=%27M4 4L0.535899 0.25L7.4641 0.25L4 4Z%27 fill=%27%23102C98%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrunAroundList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
  position: relative;
}
.TrunAroundList .LoaderContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 0.25rem;
  top: 0;
  left: 0;
  z-index: 9;
}
.TrunAroundList .HeaderSec {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.TrunAroundList .HeaderSec h1 {
  font-size: 1rem;
  font-weight: 700;
  min-width: 6.25rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.TrunAroundList .HeaderSec select {
  width: 11.25rem;
  height: 1.5rem;
  padding: 0 0.5rem;
  border: none;
  border-radius: 0.25rem;
  background: var(--Foreground);
  color: var(--TextColor);
}
.TrunAroundList .CandidateList {
  width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
}
.TrunAroundList .CandidateList .Candidate {
  display: flex;
  flex-direction: column;
  padding: 0.375rem;
  background: var(--Foreground);
  border-radius: 0.625rem;
  border: 0.0625rem solid var(--Foreground);
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1.25rem;
  padding-left: 0.5rem;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck h3 {
  flex: 1 1;
  min-width: 4.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .DaysLeft {
  width: 3.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  color: var(--TextColor);
  border: 0.0625rem solid var(--Invitation);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .DaysLeft span {
  width: 1.75rem;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 700;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .DaysLeft .Tooltip {
  display: none;
  position: absolute;
  padding: 0.5rem;
  background: var(--Foreground);
  font-size: 0.625rem;
  white-space: nowrap;
  top: -2.5rem;
  z-index: 3;
  border-radius: 0.5rem;
  box-shadow: 0 0 0.625rem var(--Stroke);
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .DaysLeft .Tooltip::after {
  position: absolute;
  bottom: -0.625rem;
  left: 50%;
  display: block;
  content: "";
  width: 1rem;
  height: 0.625rem;
  clip-path: polygon(100% 0%, 0% 0%, 50% 100%);
  background: var(--Foreground);
  transform: translateX(-50%);
  box-shadow: 0 0 0.625rem var(--Stroke);
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .DaysLeft:hover .Tooltip {
  display: block;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .LastDate {
  font-size: 0.625rem;
  font-weight: 400;
  color: var(--TextColor);
  width: 8rem;
  white-space: nowrap;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .ChekcksCount {
  padding: 0.25rem 0.5rem;
  border: 0.0625rem solid var(--Invitation);
  border-radius: 0.375rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .ChekcksCount .Check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .ChekcksCount .Check svg {
  min-width: 1rem;
  min-height: 1rem;
}
.TrunAroundList .CandidateList .Candidate .NameDateCheck .ChekcksCount .Check span {
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--TextColor);
  width: 1rem;
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper {
  width: calc(100% - 0.375rem);
  padding-left: 0.375rem;
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper .CheckListWrap {
  overflow: hidden;
  width: 100%;
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper .CheckListWrap .Checklists {
  width: 100%;
  padding-top: 0.375rem;
  margin-top: 0.375rem;
  border-top: 0.0625rem solid var(--Stroke);
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper .CheckListWrap .Checklists .Check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.375rem;
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper .CheckListWrap .Checklists .Check span {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.TrunAroundList .CandidateList .Candidate .ChecksListWrapper .CheckListWrap .Checklists .Check svg {
  min-width: 1rem;
  min-height: 1rem;
}
.TrunAroundList .CandidateList .Candidate .Show {
  grid-template-rows: 1fr;
  transition: all 0.2s ease-in-out;
}
.TrunAroundList .CandidateList .Candidate:first-child .NameDateCheck .DaysLeft {
  position: relative;
}
.TrunAroundList .CandidateList .Candidate:first-child .NameDateCheck .DaysLeft .Tooltip {
  display: none;
  position: absolute;
  padding: 0.5rem;
  background: var(--Foreground);
  font-size: 0.625rem;
  white-space: nowrap;
  top: calc(100% + 0.5rem);
  z-index: 3;
  border-radius: 0.5rem;
  box-shadow: 0 0 0.625rem var(--Stroke);
}
.TrunAroundList .CandidateList .Candidate:first-child .NameDateCheck .DaysLeft .Tooltip::after {
  position: absolute;
  top: -0.625rem;
  left: 50%;
  display: block;
  content: "";
  width: 1rem;
  height: 0.625rem;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background: var(--Foreground);
  transform: translateX(-50%);
  box-shadow: 0 0 0.625rem var(--Stroke);
}
.TrunAroundList .CandidateList .Candidate:first-child .NameDateCheck .DaysLeft:hover .Tooltip {
  display: block;
}
.TrunAroundList .CandidateList .Nearing {
  border: 0.0625rem solid var(--Cancelled);
  position: relative;
}
.TrunAroundList .CandidateList .Nearing .NameDateCheck .DaysLeft, .TrunAroundList .CandidateList .Nearing .NameDateCheck .ChekcksCount {
  border-color: var(--Cancelled);
}
.TrunAroundList .CandidateList .Expired {
  background: #F7EBEB;
  border: 0.0625rem solid var(--Cancelled);
  position: relative;
}
.TrunAroundList .CandidateList .Expired .NameDateCheck h3, .TrunAroundList .CandidateList .Expired .NameDateCheck .LastDate, .TrunAroundList .CandidateList .Expired .NameDateCheck .DaysLeft, .TrunAroundList .CandidateList .Expired .NameDateCheck .ChekcksCount {
  color: #FF5555;
}
.TrunAroundList .CandidateList .Expired .NameDateCheck .DaysLeft, .TrunAroundList .CandidateList .Expired .NameDateCheck .ChekcksCount {
  border-color: var(--Cancelled);
}
.TrunAroundList .CandidateList .Dark {
  background: rgba(250, 69, 69, 0.2235294118);
}
.TrunAroundList .CandidateList .Nearing::after {
  content: "";
  position: absolute;
  width: 0.5rem;
  height: 100%;
  background: var(--Cancelled);
  top: 0;
  left: 0;
  border-radius: 0.5rem 0 0 0.5rem;
}
.TrunAroundList .PaginationContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding-right: 0.625rem;
}
.TrunAroundList .PaginationContainer .Pagination {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  gap: 0.3125rem;
  padding-left: 1.25rem;
}
.TrunAroundList .PaginationContainer .Pagination .NextPrev {
  color: var(--TextColor);
  background: none;
  border: none;
  font-weight: 700;
  padding: 0.3125rem 0.625rem;
}
.TrunAroundList .PaginationContainer .Pagination .NextPrev:hover {
  border-radius: 1.5625rem;
  background: var(--Foreground);
}
.TrunAroundList .PaginationContainer .Pagination .PageNo {
  width: 1.5625rem;
  height: 1.5625rem;
  color: var(--TextColor);
  border-radius: 1.25rem;
  padding: 0.3125rem;
  background: none;
  border: none;
  font-weight: 700;
}
.TrunAroundList .PaginationContainer .Pagination .PageNo:hover {
  background: var(--Foreground);
}
.TrunAroundList .PaginationContainer .Pagination .CurrentPage {
  background: var(--Foreground);
}
.TrunAroundList .PaginationContainer .Pagination .disabled {
  color: #8a8a8a;
  cursor: not-allowed;
}
.TrunAroundList .PaginationContainer .ItemsPerPage {
  width: 6.25rem;
  height: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 0.0625rem solid var(--Invitation);
  border-radius: 0.5rem;
  padding-right: 0.3125rem;
}
.TrunAroundList .PaginationContainer .ItemsPerPage .OptionsLabel {
  color: var(--TextColor);
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0 0.625rem;
  border-right: 0.0625rem solid var(--Invitation);
}
.TrunAroundList .PaginationContainer .ItemsPerPage .Options {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right center;
  background-size: 0.875rem;
  width: 2.8125rem;
  height: 1.25rem;
  border: none;
  font-size: 0.75rem;
  color: var(--TextColor);
  outline: none;
}
.TrunAroundList .PaginationContainer .ItemsPerPage .Options option {
  background-color: #FFF;
  color: #363854;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/DashBoard/TrunAroundList.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAEN;AAAI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAEN;AADM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGR;AADM;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;AAGR;AAAI;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAEN;AADM;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,yCAAA;AAGR;AAFQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAIV;AAHU;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAKZ;AAHU;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAKZ;AAJY;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAMd;AAJY;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,sCAAA;AAMd;AAJY;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,4CAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;AAMd;AAFY;EACE,cAAA;AAId;AADU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AAGZ;AADU;EACE,uBAAA;EACA,yCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAGZ;AAFY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAId;AAHc;EACE,eAAA;EACA,gBAAA;AAKhB;AAHc;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAKhB;AAAQ;EACE,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;AAEV;AADU;EACE,gBAAA;EACA,WAAA;AAGZ;AAFY;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAId;AAHc;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,uBAAA;AAKhB;AAJgB;EACE,kBAAA;EACA,uBAAA;AAMlB;AAJgB;EACE,eAAA;EACA,gBAAA;AAMlB;AAAQ;EACE,uBAAA;EACA,gCAAA;AAEV;AAGU;EACE,kBAAA;AADZ;AAEY;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,UAAA;EACA,qBAAA;EACA,sCAAA;AAAd;AAEY;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,8CAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;AAAd;AAIY;EACE,cAAA;AAFd;AAOM;EACE,wCAAA;EACA,kBAAA;AALR;AAOU;EACE,8BAAA;AALZ;AASM;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;AAPR;AASU;EACE,cAAA;AAPZ;AASU;EACE,8BAAA;AAPZ;AAWM;EACE,2CAAA;AATR;AAWM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,MAAA;EACA,OAAA;EACA,gCAAA;AATR;AAYI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;AAVN;AAWM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AATR;AAUQ;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;AARV;AAUQ;EACE,wBAAA;EACA,6BAAA;AARV;AAUQ;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AARV;AAUQ;EACE,6BAAA;AARV;AAUQ;EACE,6BAAA;AARV;AAUQ;EACE,cAAA;EACA,mBAAA;AARV;AAWM;EACE,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;AATR;AAUQ;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;AARV;AAUQ;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0EAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AARV;AASU;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;AAPZ","sourcesContent":[".TrunAroundList{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    overflow: auto;\n    position: relative;\n    .LoaderContainer{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: absolute;\n      border-radius: 0.25rem;\n      top: 0;\n      left: 0;\n      z-index: 9;\n    }\n    .HeaderSec{\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.75rem;\n      h1{\n        font-size: 1rem;\n        font-weight: 700;\n        min-width: 6.25rem;\n        color: var(--TextColor);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      select{\n        width: 11.25rem;\n        height: 1.5rem;\n        padding: 0 0.5rem;\n        border: none;\n        border-radius: 0.25rem;\n        background: var(--Foreground);\n        color: var(--TextColor);\n      }\n    }\n    .CandidateList{\n      width: 100%;\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      overflow: auto;\n      .Candidate{\n        display: flex;\n        flex-direction: column;\n        padding: 0.375rem;\n        background: var(--Foreground);\n        border-radius: 0.625rem;\n        border: 0.0625rem solid var(--Foreground);\n        .NameDateCheck{\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n          align-items: center;\n          gap: 0.5rem 1.25rem;\n          padding-left: 0.5rem;\n          h3{\n            flex: 1;\n            min-width: 4.5rem;\n            font-size: 0.875rem;\n            font-weight: 500;\n            color: var(--TextColor);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            cursor: pointer;\n          }\n          .DaysLeft{\n            width: 3.5rem;\n            height: 1.5rem;\n            border-radius: 0.375rem;\n            color: var(--TextColor);\n            border: 0.0625rem solid var(--Invitation);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            cursor: pointer;\n            span{\n              width: 1.75rem;\n              text-align: center;\n              font-size: 0.75rem;\n              font-weight: 700;\n            }\n            .Tooltip{\n              display: none;\n              position: absolute;\n              padding: 0.5rem;\n              background: var(--Foreground);\n              font-size: 0.625rem;\n              white-space: nowrap;\n              top: -2.5rem;\n              z-index: 3;\n              border-radius: 0.5rem;\n              box-shadow: 0 0 0.625rem var(--Stroke);\n            }\n            .Tooltip::after{\n              position: absolute;\n              bottom: -0.625rem;\n              left: 50%;\n              display: block;\n              content: '';\n              width: 1rem;\n              height: 0.625rem;\n              clip-path: polygon(100% 0%, 0% 0%, 50% 100%);\n              background: var(--Foreground);\n              transform: translateX(-50%);\n              box-shadow: 0 0 0.625rem var(--Stroke);\n            }\n          }\n          .DaysLeft:hover{\n            .Tooltip{\n              display: block;\n            }\n          }\n          .LastDate{\n            font-size: 0.625rem;\n            font-weight: 400;\n            color: var(--TextColor);\n            width: 8rem;\n            white-space: nowrap;\n          }\n          .ChekcksCount{\n            padding: 0.25rem 0.5rem;\n            border: 0.0625rem solid var(--Invitation);\n            border-radius: 0.375rem;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.5rem;\n            cursor: pointer;\n            .Check{\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              gap: 0.25rem;\n              svg{\n                min-width: 1rem;\n                min-height: 1rem;\n              }\n              span{\n                font-size: 0.625rem;\n                font-weight: 500;\n                color: var(--TextColor);\n                width: 1rem;\n              }\n            }\n          }\n        }\n        .ChecksListWrapper{\n          width: calc(100% - 0.375rem);\n          padding-left: 0.375rem;\n          display: grid;\n          grid-template-rows: 0fr;\n          overflow: hidden;\n          transition: all 0.2s ease-in-out;\n          .CheckListWrap{\n            overflow: hidden;\n            width: 100%;\n            .Checklists{\n              width: 100%;\n              padding-top: 0.375rem;\n              margin-top: 0.375rem;\n              border-top: 0.0625rem solid var(--Stroke);\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              flex-wrap: wrap;\n              gap: 0.75rem;\n              .Check{\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 0.5rem;\n                padding: 0.25rem 0.5rem;\n                border: 0.0625rem solid var(--Stroke);\n                border-radius: 0.375rem;\n                span{\n                  font-size: 0.75rem;\n                  color: var(--TextColor);\n                }\n                svg{\n                  min-width: 1rem;\n                  min-height: 1rem;\n                }\n              }\n            }\n          }\n        }\n        .Show{\n          grid-template-rows: 1fr;\n          transition: all 0.2s ease-in-out;\n        }\n      }\n      .Candidate:first-child{\n        .NameDateCheck{\n          .DaysLeft{\n            position: relative;\n            .Tooltip{\n              display: none;\n              position: absolute;\n              padding: 0.5rem;\n              background: var(--Foreground);\n              font-size: 0.625rem;\n              white-space: nowrap;\n              top: calc(100% + 0.5rem);\n              z-index: 3;\n              border-radius: 0.5rem;\n              box-shadow: 0 0 0.625rem var(--Stroke);\n            }\n            .Tooltip::after{\n              position: absolute;\n              top: -0.625rem;\n              left: 50%;\n              display: block;\n              content: '';\n              width: 1rem;\n              height: 0.625rem;\n              clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n              background: var(--Foreground);\n              transform: translateX(-50%);\n              box-shadow: 0 0 0.625rem var(--Stroke);\n            }\n          }\n          .DaysLeft:hover{\n            .Tooltip{\n              display: block;\n            }\n          }\n        }\n      }\n      .Nearing{\n        border: 0.0625rem solid var(--Cancelled);\n        position: relative;\n        .NameDateCheck{\n          .DaysLeft, .ChekcksCount{\n            border-color: var(--Cancelled);\n          }\n        }\n      }\n      .Expired{\n        background: #F7EBEB;\n        border: 0.0625rem solid var(--Cancelled);\n        position: relative;\n        .NameDateCheck{\n          h3, .LastDate, .DaysLeft, .ChekcksCount{\n            color: #FF5555;\n          }\n          .DaysLeft, .ChekcksCount{\n            border-color: var(--Cancelled);\n          }\n        }\n      }\n      .Dark{\n        background: #fa454539;\n      }\n      .Nearing::after{\n        content: '';\n        position: absolute;\n        width: 0.5rem;\n        height: 100%;\n        background: var(--Cancelled);\n        top: 0;\n        left: 0;\n        border-radius: 0.5rem 0 0 0.5rem;\n      }\n    }\n    .PaginationContainer{\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n      padding-right: 0.625rem;\n      .Pagination{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        height: 100%;\n        gap: 0.3125rem;\n        padding-left: 1.25rem;\n        .NextPrev{\n          color: var(--TextColor);\n          background: none;\n          border: none;\n          font-weight: 700;\n          padding: 0.3125rem 0.625rem;\n        }\n        .NextPrev:hover{\n          border-radius: 1.5625rem;\n          background: var(--Foreground);\n        }\n        .PageNo{\n          width: 1.5625rem;\n          height: 1.5625rem;\n          color: var(--TextColor);\n          border-radius: 1.25rem;\n          padding: 0.3125rem;\n          background: none;\n          border: none;\n          font-weight: 700;\n        }\n        .PageNo:hover{\n          background: var(--Foreground);\n        }\n        .CurrentPage{\n          background: var(--Foreground);\n        }\n        .disabled{\n          color: #8a8a8a;\n          cursor: not-allowed;\n        }\n      }\n      .ItemsPerPage{\n        width: 6.25rem;\n        height: 1.5rem;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        border: 0.0625rem solid var(--Invitation);\n        border-radius: 0.5rem;\n        padding-right: 0.3125rem;\n        .OptionsLabel{\n          color: var(--TextColor);\n          font-size: 0.75rem;\n          font-weight: 500;\n          padding: 0 0.625rem;\n          border-right: 0.0625rem solid var(--Invitation);\n        }\n        .Options{\n          appearance: none;\n          -webkit-appearance: none;\n          -moz-appearance: none;\n          background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='5' viewBox='0 0 8 4'%3E%3Cpath d='M4 4L0.535899 0.25L7.4641 0.25L4 4Z' fill='%23102C98'/%3E%3C/svg%3E\") no-repeat right center;\n          background-size: 0.875rem;\n          width: 2.8125rem;\n          height: 1.25rem;\n          border: none;\n          font-size: 0.75rem;\n          color: var(--TextColor);\n          outline: none;\n          option{\n            background-color: #FFF;\n            color: #363854;\n            text-align: center;\n          }\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
